import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="mx-auto w-full max-w-7xl px-4 pt-6 md:px-6">
      <ol className="flex flex-wrap items-center gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="flex items-center gap-1 transition-colors hover:text-primary-600">
            <i className="ri-home-5-line" />
            首页
          </Link>
        </li>
        {items.map((item, idx) => (
          <li key={`${item.label}-${idx}`} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line" />
            {item.path ? (
              <Link to={item.path} className="transition-colors hover:text-primary-600">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}